<template>
    <div class="mail-list">

        <div class="msg-page-in-dev">У вас нет черновиков</div>

    </div>
</template>

<script>
    export default {
        name: "EmptyDrafts"
    }
</script>

<style scoped>

</style>